import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LayoutsService {
  isWide = signal(false);
  isFullscreen = signal(false);

  constructor() {}
}
